import { render, staticRenderFns } from "./ClaimsValueEmployerChart.vue?vue&type=template&id=590ae81d&scoped=true"
import script from "./ClaimsValueEmployerChart.vue?vue&type=script&lang=js"
export * from "./ClaimsValueEmployerChart.vue?vue&type=script&lang=js"
import style0 from "./ClaimsValueEmployerChart.vue?vue&type=style&index=0&id=590ae81d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ae81d",
  null
  
)

export default component.exports